// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@awc/XDL/Utilities";
import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { css } from "styled-components";

actionsStyles.buttonsHidden = {
    css: css`
        display: flex;
    `,
};

actionsStyles.addAllToCartButton = {
    sizeVariant: "small",
    variant: "tertiary",
    css: css`
        margin-left: 10px;
        ${xScreen("lte", "sm")} {
            margin-left: 0;
        }
    `,
};

actionsStyles.addToListButton = {
    variant: "tertiary",
    sizeVariant: "small",
    css: css`
        margin-left: 10px;
        ${xScreen("lte", "sm")} {
            margin-left: 0;
            display: block;
            width: 100%;
        }
    `,
};

actionsStyles.uploadOrderButton = {
    sizeVariant: "small",
    variant: "link" as any,
    css: css`
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

actionsStyles.overflowMenu = {
    buttonProps: {
        css: css`
            margin-left: 2px;
        `,
    },
    cssOverrides: {
        wrapper: css`
            width: 28px;
            height: 28px;
        `,
    },
};

actionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
};
